export enum TabNameEnum {
  SENT_EMAILS = 'sent-emails',
  RECEIVED_EMAILS = 'received-emails',
}
